import { render, staticRenderFns } from "./HomeChime.vue?vue&type=template&id=4c2dced2&scoped=true&"
import script from "./HomeChime.vue?vue&type=script&lang=js&"
export * from "./HomeChime.vue?vue&type=script&lang=js&"
import style0 from "./HomeChime.vue?vue&type=style&index=0&id=4c2dced2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2dced2",
  null
  
)

export default component.exports